<template>
  <BaseDropdown>
    <template #trigger="{ isActive }">
      <HeaderIconButton :is-active="isActive">
        <template #icon>
          <SplitCircleSvg />
        </template>
        <template #label>
          Change layout
        </template>
      </HeaderIconButton>
    </template>

    <template #content="{ tippy }">
      <BaseDropdownHeading>
        Change layout

        <template #lead>
          Description goes here for this dropdown.
        </template>
      </BaseDropdownHeading>
      <BaseDropdownActionsList>
        <BaseDropdownActionRadio
          v-for="option in options"
          :key="option.value"
          v-model="model"
          :value="option.value"
          @change="tippy.hide"
        >
          {{ option.label }}
        </BaseDropdownActionRadio>
      </BaseDropdownActionsList>
    </template>
  </BaseDropdown>
</template>

<script>
import BaseDropdown, {
  DropdownActionRadio as BaseDropdownActionRadio, DropdownHeading as BaseDropdownHeading,
  DropdownActionsList as BaseDropdownActionsList,
} from '@/components/base/Dropdown';
import HeaderIconButton from '@/components/HeaderIconButton';
import SplitCircleSvg from '@/assets/images/icons/split-circle.svg?inline';

export default {
  components: {
    BaseDropdown,
    BaseDropdownHeading,
    BaseDropdownActionRadio,
    BaseDropdownActionsList,
    HeaderIconButton,
    SplitCircleSvg,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: null,
      default: null,
    },
  },
  emits: {
    'update:modelValue': null,
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
};
</script>

<style lang="scss" module>

</style>
